// components/PostForm.jsx
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, message, Card } from "antd";
import { PlusOutlined, SaveOutlined } from "@ant-design/icons";
import { useTags } from "../hooks/useBlogAPI";

const { Option } = Select;

const PostForm = ({ initialValues, onSubmit, onCancel, mode = "create" }) => {
  const [form] = Form.useForm();
  const [previewMode, setPreviewMode] = useState(false); //切换预览模式
  const [content, setContent] = useState(initialValues?.content || ""); //文章内容
  const { data: availableTags } = useTags(); //可选标签

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
      setContent(initialValues.content || "");
    }
  }, [initialValues, form]);
  const handleSubmit = async (values) => {
    try {
      await onSubmit(values);
      message.success(mode === "create" ? "文章创建成功！" : "文章更新成功！");
    } catch (error) {
      message.error(
        mode === "create" ? "文章创建失败，请重试" : "文章更新失败，请重试"
      );
    }
  };

  const handleContentChange = (e) => {
    const value = e.target.value;
    setContent(value);
  };

  return (
    <Card
      title={mode === "create" ? "创建新文章" : "编辑文章"}
      extra={
        <Button onClick={() => setPreviewMode(!previewMode)}>
          {previewMode ? "编辑模式" : "预览模式"}
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleSubmit}
      >
        <Form.Item
          label="标题"
          name="title"
          rules={[{ required: true, message: "请输入文章标题" }]}
        >
          <Input placeholder="输入文章标题" size="large" />
        </Form.Item>

        <Form.Item label="标签" name="tags">
          <Select mode="tags" placeholder="添加标签" tokenSeparators={[","]}>
            /* 提供预定义的标签选项 */
            {availableTags?.map((tag) => (
              <Option key={tag.name} value={tag.name}>
                {tag.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="内容"
          name="content"
          rules={[{ required: true, message: "请输入文章内容" }]}
        >
          {previewMode ? (
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: 6,
                padding: 12,
                minHeight: 300,
                whiteSpace: "pre-wrap",
              }}
            >
              {content}
            </div>
          ) : (
            <Input.TextArea
              rows={15}
              placeholder="在此输入文章内容"
              onChange={handleContentChange}
              value={content}
            />
          )}
        </Form.Item>

        <Form.Item>
          <Button.Group>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              {mode === "create" ? "创建文章" : "保存更改"}
            </Button>
            <Button onClick={onCancel}>取消</Button>
          </Button.Group>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default PostForm;
